/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import PropTypes from 'prop-types';
import React__default from 'react';
import { IdPrefixContext } from '../../internal/useIdPrefix.js';

function IdPrefix(_ref) {
  let {
    children,
    prefix
  } = _ref;
  return /*#__PURE__*/React__default.createElement(IdPrefixContext.Provider, {
    value: prefix
  }, children);
}
IdPrefix.propTypes = {
  children: PropTypes.node,
  /**
   * The value used to prefix the auto-generated id placed on some DOM elements
   */
  prefix: PropTypes.string
};

export { IdPrefix };
